import { Panel } from "@/components/dashboard/Panel";
import { L } from "@/i18n";

const ALL = Array.from({ length: 17 }, (_, i) => `M${i + 1}`);

export const ProgressSummary = ({ modules, concluded, failed, failedCount }) => {
  const done = new Set((concluded ?? []).map((m) => m.module));
  const fail = new Set((failed ?? []).map((m) => m.module));
  const allowed = new Set(modules ?? []);
  const tone = (m) =>
    done.has(m) ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/40"
      : fail.has(m) ? "bg-rose-500/15 text-rose-300 border-rose-500/40"
      : allowed.has(m) ? "bg-slate-800 text-slate-300 border-slate-700"
      : "bg-transparent text-slate-600 border-slate-800";

  return (
    <Panel title={L("Module map", "Mapa de módulos")} subtitle={L("Completed · Failed · Access · No access", "Concluídos · Reprovados · Com acesso · Sem acesso")} testId="student-module-map">
      <div className="grid grid-cols-6 sm:grid-cols-9 gap-2">
        {ALL.map((m) => (
          <span key={m} className={`rounded-md border py-2 text-center font-mono text-xs ${tone(m)}`} data-testid={`module-map-${m}`}>{m}</span>
        ))}
      </div>
      <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs">
        {[
          [L("Completed", "Concluídos"), done.size, "text-emerald-400", "student-count-concluded"],
          [L("Failed", "Reprovados"), fail.size, "text-rose-400", "student-count-failed"],
          [L("With access", "Com acesso"), allowed.size, "text-slate-200", "student-count-allowed"],
          [L("Failed questions", "Perguntas falhadas"), failedCount ?? "—", "text-amber-400", "student-count-failed-questions"],
        ].map(([l, v, c, t]) => (
          <div key={l} className="rounded-md bg-[#0f172a] p-3">
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{l}</p>
            <p className={`mt-1 font-mono text-xl font-bold ${c}`} data-testid={t}>{v}</p>
          </div>
        ))}
      </div>
    </Panel>
  );
};
